// extracted by mini-css-extract-plugin
export default {"wrapper":"InboxCounter__wrapper--2yV","counter":"InboxCounter__counter--1lG"};